<template>
  <div class="row ">
    <div class="flex sm12 xl12 xs12">
        <div class="row ">
            <div class="flex text-center md12">
                    <p  style="font-size: 30px"> {{$t('dashboard.SistemaGestao')}}</p>
                    <hr>
            </div>
          
           
        </div>
      <div class=" row">
   

            <div class=" flex sm4 xs12 xl4"  >
                    
            <va-button class="mb-12" :color="GestaoCursos.color" :style="GestaoCursos" :to="GestaoCursos.rota"  >
                <p  class="display-3" style="color: white"> {{$t('dashboard.GestaoCursos')}} </p>
            </va-button>       
            </div>

            <div class=" flex sm4 xs12 xl4" >
            <va-button class="mb-12 " :color="GestaoConteudo.color" :style="GestaoConteudo" :to="GestaoConteudo.rota"> 
                <p class="display-3 mb-0 text-center" style="color: white">{{$t('dashboard.GestaoConteudo')}}</p>
            </va-button>       
            </div>

            <div class=" flex sm4 xs12 xl4 text-center" >
            <va-button class="mb-12 text-center " :color="GestaoFuncionarios.color" :style="GestaoFuncionarios" :to="GestaoFuncionarios.rota">
                <p class="display-3 mb-0 text-center" style="color: white">{{$t('dashboard.GestaoFuncionarios')}}</p>
            </va-button> 
            </div>

            
       
       
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'botoesinicial',
  data () {
    return {
      GestaoCursos: {
        rota: {name:'cursos'},
        color:'info',
        'min-height': '50px',
        'min-width': '100%',
                    }, 
      GestaoConteudo:{
        rota: {name:'home'},
        color:'success',
        'min-height': '50px',
        'min-width': '100%',
                     }, 
      GestaoFuncionarios:{
        rota: {name:'home'},
        color: 'dark',
        'min-height': '50px',
        'min-width': '100%',
       
                        },
    }
  },
}
</script>

<style lang="scss">
  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2){
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }

    .va-card__image {
      @include media-breakpoint-up(md) {
        padding-bottom: 0 !important;
      }
    }
  }
</style>
